import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  InputAdornment,
  Paper,
} from '@mui/material';
import AddIcon from '@material-ui/icons/Add';
import CandidateService from '../../../services/candidateService';


const menuItemStyles = {
  display: "flex",
  alignItems: "center",
  maxWidth: "400px", // Adjust the maximum width as needed
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "pre-wrap",
  wordWrap: "break-word",
};



function CustomSelect({ options, setOptions, name, value, onChange, fieldName, fetchOptions }) {
  const [showPopup, setShowPopup] = useState(false);
  const [newOption, setNewOption] = useState('');
  const [sortedOptions, setSortedOptions] = useState(options);

  const handleChange = (e) => {
    onChange(e);
  };

  const createOption = async () => {
    const groupName = 'A';

    try {
      const requestBody = {
        groupName,
        fieldName,
        value,
        label: newOption,
      };
      requestBody.value = newOption.replace(/\s+/g, '-').toLowerCase();
      const response = await CandidateService.createOption(requestBody);
      const createdOption = response.data;

      // Fetch options again
      fetchOptions();
      console.log('New option created:', newOption);
    } catch (error) {
      console.error('Error creating option:', error);
    }
  };

  const handleAddCustomOption = () => {
    createOption();
    closePopup();
  };

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setNewOption('');
  };

  // Sort the options alphabetically

  React.useEffect(() => {
    if (Array.isArray(options)) {
      const sortedOptions_ = [...options].sort((a, b) => a.label.localeCompare(b.label));
      setSortedOptions(sortedOptions_);
    }
    console.log(sortedOptions)
  }, [options]);
  

  const autocompleteChange = (event, newValue) => {
    const e = 
    {
     target: {
      name: name,
      value: newValue?.label,
    }
   }
    onChange(e);
  };


  return (
    <>
    {sortedOptions && sortedOptions.length > 0 &&
  <Autocomplete
  id={name}
  value={value}
  onChange={autocompleteChange}
  fullWidth
  autoComplete="off"
  size="small"
  options={sortedOptions}
  renderInput={(params) => (
    <TextField
      {...params}
      label={name}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <Button onClick={openPopup} style={menuItemStyles}>
              <AddIcon />
              Add
            </Button>
          </InputAdornment>
        ),
      }}
    />
  )}
 renderOption={(option) => {
  return (
    <li {...option}>
    {option.key}
  </li>
  );
}}

/>

    }
  


     {/* <Select
        name={name}
        value={value}
        onChange={handleChange}
        fullWidth
        autoComplete="off"
        size="small"
      >
        {sortedOptions?.map((option, index) => (
          <MenuItem key={index} value={option.label} style={menuItemStyles}>
            {option.label}
          </MenuItem>
        ))}
        <MenuItem>
          <Button onClick={openPopup} style={menuItemStyles}>
            <AddIcon />
            Add Custom Option
          </Button>
        </MenuItem>
      </Select> */}


      <Dialog open={showPopup} onClose={closePopup}>
        <DialogTitle>Add Custom Option</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            label="Custom Option"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closePopup}>Cancel</Button>
          <Button onClick={handleAddCustomOption} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomSelect;
